import { render, staticRenderFns } from "./ProdutoAssociarModal.vue?vue&type=template&id=71013164&"
import script from "./ProdutoAssociarModal.vue?vue&type=script&lang=js&"
export * from "./ProdutoAssociarModal.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoAssociarModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports